module.exports = __webpack_public_path__ + "static/media/community.7a7636be.png";